import BasePreset from '../base/BasePreset.js'
import fragSrc    from '../../shaders/presets/neon/fragment.glsl'

export default class NeonPreset extends BasePreset {
    constructor() {
        super()
        this.id   = 'neon'
        this.name = 'Neon'
        this.plan = 'free'
        this.defaultObjectColor = '#00ffcc'
        this.defaultBgColor     = '#010208'
    }

    init(canvas) {
        this._setup(canvas, fragSrc)
        const gl = this.gl
        this.uniforms.uObjectColor  = gl.getUniformLocation(this._program, 'uObjectColor')
        this.uniforms.uBgColor      = gl.getUniformLocation(this._program, 'uBgColor')
        this.uniforms.uWaveCount    = gl.getUniformLocation(this._program, 'uWaveCount')
        this.uniforms.uWaveDir      = gl.getUniformLocation(this._program, 'uWaveDir')
        this.uniforms.uGradientIdx  = gl.getUniformLocation(this._program, 'uGradientIdx')
        this.uniforms.uScale        = gl.getUniformLocation(this._program, 'uScale')
    }

    getSchema(plan) {
        if (plan === 'free') return []
        const fields = [
            { key: 'objectColor', type: 'color', label: 'Wave Color', default: this.defaultObjectColor },
            { key: 'bgColor',     type: 'color', label: 'Background', default: this.defaultBgColor },
        ]
        if (plan === 'pro') {
            fields.push(
                { key: 'waveCount',   type: 'range',  label: 'Wave Count', min: 3, max: 12, step: 1, default: 7 },
                { key: 'waveDir',     type: 'range',  label: 'Wave Tilt',  min: 0, max: 360, step: 1, default: 0 },
                {
                    key: 'gradientIdx', type: 'select', label: 'Gradient',
                    options: [
                        { value: 0, label: 'Neon (default)' },
                        { value: 1, label: 'Warm' },
                        { value: 2, label: 'Cool' },
                        { value: 3, label: 'Mono' },
                    ],
                    default: 0,
                },
            )
        }
        return fields
    }

    _applyConfigUniforms() {
        const gl = this.gl
        const [or, og, ob] = this._hexToRgb(this._config.objectColor ?? this.defaultObjectColor)
        gl.uniform3f(this.uniforms.uObjectColor, or, og, ob)
        const [br, bg, bb] = this._hexToRgb(this._config.bgColor ?? this.defaultBgColor)
        gl.uniform3f(this.uniforms.uBgColor, br, bg, bb)
        gl.uniform1i(this.uniforms.uWaveCount,   Math.round(Number(this._config.waveCount   ?? 7)))
        gl.uniform1f(this.uniforms.uWaveDir,     Number(this._config.waveDir     ?? 0))
        gl.uniform1i(this.uniforms.uGradientIdx, Math.round(Number(this._config.gradientIdx ?? 0)))
        gl.uniform1f(this.uniforms.uScale,        Number(this._config.scale ?? 1.0))
    }
}
